export enum CustomWindowEvents {
	CHANGE_SEASON = "changeSeason",
}
